// Пропорции видеофайла из его метаданных, в виде "1080/1920" для fancybox.
// Без них плеер уедет в дефолтный горизонтальный слот: вертикальный ролик
// станет полоской, а нативные контролы растянутся на всю ширину подложки.
// Если метаданные не пришли (ошибка, долгий ответ) — возвращаем null,
// чтобы не задерживать открытие.
export default function videoAspectRatio(src, timeout = 3000) {
    return new Promise((resolve) => {
        const probe = document.createElement("video");
        let timer;

        const finish = (ratio) => {
            clearTimeout(timer);
            probe.removeAttribute("src");
            probe.load();
            resolve(ratio);
        };

        timer = setTimeout(() => finish(null), timeout);

        probe.addEventListener("loadedmetadata", () => {
            const { videoWidth: w, videoHeight: h } = probe;
            finish(w && h ? `${w}/${h}` : null);
        });
        probe.addEventListener("error", () => finish(null));

        probe.preload = "metadata";
        probe.muted = true;
        probe.src = src;
    });
}
